import {reject, isNil} from 'ramda';

import {CustomerAdvancedSearchResultResponseBody} from '@dms/api/customer';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import {isInvalidEmail} from '../../../utils/isInvalidEmail';

export const getAdvancedCustomerEmails = (
  customer: CustomerAdvancedSearchResultResponseBody | Nullish
) => {
  const emails =
    customer?.discriminator === 'BUSINESS'
      ? customer?.contacts.flatMap((contact) => contact.email)
      : [customer?.foundingPerson?.email];

  const uniqueEmails = new Set(reject(isNil, emails ?? []));

  // The send endpoints refuse an invalid recipient, so it is shown but cannot be chosen
  return Array.from(uniqueEmails).map((email) => ({
    value: email,
    label: isInvalidEmail(email)
      ? `${email} (${i18n.t('general.validations.invalidEmail')})`
      : email,
    isDisabled: isInvalidEmail(email),
  }));
};
